export const getRetailerTypes = ({ retailer, dealerData }) => {
  const { type, isHiddenRCPO, brand, rolexIsFlagship, isAffiliate, serviceCenterSameAddress } = retailer
  const hasBrand = brand && brand.length > 0
  const effectiveBrand = hasBrand ? brand : dealerData?.brand || []

  const typeList = []

  if (rolexIsFlagship) typeList.push("boutique")

  if (effectiveBrand?.includes("RLX") && !isAffiliate) typeList.push("retailer")

  if (type?.includes("SERVICE") || (serviceCenterSameAddress !== "" && serviceCenterSameAddress !== undefined)) typeList.push("servicecenter")

  if (effectiveBrand?.includes("RCPO") && !isHiddenRCPO) typeList.push("cpo")

  return typeList
}

export const getOpenHours = ({ retailer, DateTime, day, date, lang, isRTL }) => {
  let isStoreOpen
  const { hoursTranslatedDetails, timezone } = retailer

  const open1 = hoursTranslatedDetails[day - 1].open1
  const open2 = hoursTranslatedDetails[day - 1].open2
  const open3 = hoursTranslatedDetails[day - 1].open3
  const close1 = hoursTranslatedDetails[day - 1].close1
  const close2 = hoursTranslatedDetails[day - 1].close2
  const close3 = hoursTranslatedDetails[day - 1].close3

  const currentDateTime = DateTime.utc()

  const dateOpen1 = currentDateTime.setZone(timezone.timeZoneId).set(DateTime.fromFormat(open1, "T").toObject())
  const dateOpen2 = open2 !== "" ? currentDateTime.setZone(timezone.timeZoneId).set(DateTime.fromFormat(open2, "T").toObject()) : null
  const dateOpen3 = open3 !== "" ? currentDateTime.setZone(timezone.timeZoneId).set(DateTime.fromFormat(open3, "T").toObject()) : null
  const dateClose1 = currentDateTime.setZone(timezone.timeZoneId).set(DateTime.fromFormat(close1, "T").toObject())
  const dateClose2 = close2 !== "" ? currentDateTime.setZone(timezone.timeZoneId).set(DateTime.fromFormat(close2, "T").toObject()) : null
  const dateClose3 = close3 !== "" ? currentDateTime.setZone(timezone.timeZoneId).set(DateTime.fromFormat(close3, "T").toObject()) : null

  const dateNow = lang !== "ja" ? date.setLocale(lang) : date

  isStoreOpen =
    dateOpen3 != null
      ? (dateOpen1.ts < dateNow.ts && dateNow.ts < dateClose1.ts) ||
        (dateOpen2.ts < dateNow.ts && dateNow.ts < dateClose2.ts) ||
        (dateOpen3.ts < dateNow.ts && dateNow.ts < dateClose3.ts)
      : dateOpen2 !== null
        ? (dateOpen1.ts < dateNow.ts && dateNow.ts < dateClose1.ts) || (dateOpen2.ts < dateNow.ts && dateNow.ts < dateClose2.ts)
        : dateOpen1.ts < dateNow.ts && dateNow.ts < dateClose1.ts

  const currentOpeningHour = isRTL
    ? hoursTranslatedDetails[day - 1].hoursDayTranslatedRtl.replaceAll(" - ", "&nbsp;-&nbsp;").replaceAll(", ", "<br>")
    : hoursTranslatedDetails[day - 1].hoursDayTranslated.replaceAll(" - ", "&nbsp;-&nbsp;").replaceAll(", ", "<br>")

  return { isStoreOpen, currentOpeningHour }
}
